/* ==========================================================================
   blend · funnel tracking engine  (storefront layer)
   --------------------------------------------------------------------------
   Reads window.__blendPage (set by snippets/blend-page-context.liquid) and
   window.__blendCfg (set by snippets/blend-tracking.liquid), then fans enriched
   funnel events out to GA4 + PostHog + Clarity. Every event carries the page's
   funnel / role / step, so drop-off can be attributed by funnel and by stage:

     advertorial_view → cta_click → view_item (PDP) → add_to_cart → [checkout]

   The checkout stages (begin_checkout, add_payment_info, purchase) are owned by
   the Customer-Events Web Pixel (theme/_tracking/), because theme JS cannot run
   on Shopify's locked checkout. No event is fired in both places — no dupes.

   window.blendTrack(name, props) is exposed for manual/custom events.
   ========================================================================== */
(function () {
  var CFG = window.__blendCfg || {};
  var P = window.__blendPage || { funnel: 'unmapped', role: 'other', step: 0 };
  if (CFG.designMode) return; // never track inside the theme editor

  // utm_campaign is the stable thread across a funnel: the advertorial appends it to its
  // PDP link, so the PDP carries it on arrival. Fall back to the page's own funnel id when
  // it's absent (e.g. the advertorial landing itself). This is what stitches step 1 → step 2,
  // since each page declares its OWN funnel id (adv1 vs pdp2) which otherwise wouldn't match.
  function campaign() {
    try {
      var c = new URLSearchParams(location.search).get('utm_campaign');
      if (c) return c;
    } catch (e) {}
    return P.funnel;
  }

  function base() {
    return {
      funnel: P.funnel,
      campaign: campaign(),
      page_role: P.role,
      funnel_step: P.step,
      page_name: P.name,
      page_template: P.template,
      page_path: (location && location.pathname) || P.url
    };
  }

  function track(name, props) {
    var payload = Object.assign(base(), props || {});
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload)); } catch (e) {}
    try { if (window.gtag) window.gtag('event', name, payload); } catch (e) {}
    try { if (window.posthog && window.posthog.capture) window.posthog.capture(name, payload); } catch (e) {}
    if (CFG.debug) { try { console.log('[blend-track]', name, payload); } catch (e) {} }
  }
  window.blendTrack = track;

  // ---- register persistent context so EVERY auto event is segmentable ----
  try {
    if (window.posthog && window.posthog.register) {
      window.posthog.register({ funnel: P.funnel, campaign: campaign(), page_role: P.role, funnel_step: P.step });
    }
  } catch (e) {}
  // Clarity custom tags → filter session recordings/heatmaps by funnel & role
  try {
    if (window.clarity) {
      window.clarity('set', 'funnel', String(P.funnel));
      window.clarity('set', 'page_role', String(P.role));
      window.clarity('set', 'funnel_step', String(P.step));
    }
  } catch (e) {}

  // ---- page-entry events ----
  function onReady() {
    track('funnel_step', { step_event: 'page_view' });

    if (P.role === 'advertorial') {
      track('advertorial_view', {});
    } else if (P.role === 'pdp') {
      // GA4 ecommerce-style view + a clean PDP signal for PostHog funnels
      track('view_item', {});
      track('pdp_view', {});
    }

    // ---- CTA clicks (advertorial → PDP transition signal) ----
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest
        ? e.target.closest('a.btn, .nav__cta, [data-cta], a[href*="/products/"], a[href*="/pages/"]')
        : null;
      if (!el) return;
      // ATC is captured by the /cart/add.js hook below — don't double-count here
      if (el.matches('[data-atc], .wbs__atc')) return;
      var href = el.getAttribute('href') || '';
      track('cta_click', {
        link_url: href,
        link_text: (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
        to_pdp: /\/products\//.test(href) || /pdp|smooche|rip-resistant/.test(href)
      });
    }, { passive: true });
  }

  // ---- Add-to-cart: hook the cart AJAX endpoint (selector-independent) ----
  (function hookAddToCart() {
    if (!window.fetch || window.__blendFetchHooked) return;
    window.__blendFetchHooked = true;
    var _fetch = window.fetch;
    window.fetch = function () {
      var url = '';
      try { url = (arguments[0] && arguments[0].url) || String(arguments[0] || ''); } catch (e) {}
      var p = _fetch.apply(this, arguments);
      try {
        if (url.indexOf('/cart/add') !== -1) {
          p.then(function (r) { if (r && r.ok) track('add_to_cart', { source: 'storefront' }); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
